export default __webpack_public_path__ + "static/media/Globe Life dark.68afe7da.svg";